import React from 'react';
import EntryTypeStep from './steps/EntryTypeStep';
//import AttachmentStep from './steps/AttachmentStep';
import TemplateSelectionStep from './steps/TemplateSelectionStep';
import DetailsEntryStep from './steps/DetailsEntryStep';
import PreviewStep from './steps/PreviewStep';
import NewTemplatePreviewStep from './steps/NewTemplatePreviewStep';

import { useHistory } from 'react-router-dom';

const STEPS = {
    ENTRY_TYPE: 'step_1_entry_type',
    //ATTACHMENTS: 'step_2_attachments',
    TEMPLATE: 'step_3_template',
    DETAILS: 'step_4_details',
    PREVIEW: 'step_5_preview'
};

const BookkeepingStepContent = ({
    activeStep,
    entry,
    setEntry,
    templates,
    accounts,
    templatesLoading,
    accountsLoading,
    templatesError,
    accountsError,
    companyId,
    handleTemplateSelect,
    fetchTemplates,
    getAccountByNumber,
    getAccountsByType,
    searchAccounts,
    operationInProgress
}) => {
    const history = useHistory();

    const renderStepContent = () => {
        switch (activeStep) {
            case STEPS.ENTRY_TYPE:
                return (
                    <EntryTypeStep
                        selectedType={entry.entryType}
                        onSelect={(type) => setEntry({ ...entry, entryType: type })}
                        onManualEntry={() => history.push(`/${companyId}/manual-bookkeeping-entry`)}
                    />
                );



            case STEPS.TEMPLATE:
                return (
                    <TemplateSelectionStep
                        entryType={entry.entryType}
                        selectedTemplate={entry.template}
                        onSelect={handleTemplateSelect}
                        templates={templates}
                        loading={templatesLoading}
                        error={templatesError}
                        onRetry={fetchTemplates}
                    />
                );

            case STEPS.DETAILS:
                // DetailsEntryStep is shape-aware — handles legacy
                // parameters[]+transactions[] AND new-shape body.inputs
                // via getEffectiveInputs(). All attachments, validation,
                // completion badges, and styling preserved for both.
                return (
                    <DetailsEntryStep
                        entry={entry}
                        onChange={(updatedEntry) => setEntry(updatedEntry)}
                        companyId={companyId}
                        accounts={accounts}
                        accountsLoading={accountsLoading}
                        accountsError={accountsError}
                        getAccountByNumber={getAccountByNumber}
                        getAccountsByType={getAccountsByType}
                        searchAccounts={searchAccounts}
                    />
                );

            case STEPS.PREVIEW:
                // Same shape branch as DETAILS — new-shape templates
                // get a server-driven preview via /suggest; legacy use
                // the client-side PreviewStep against parameters[] +
                // transactions[].
                if (entry.templateData && entry.templateData.body) {
                    // Thin wrapper that calls /suggest and pre-
                    // populates entry.customJournalEntries, then
                    // renders the FULL legacy PreviewStep underneath
                    // (with all its UX: editable entries, balance
                    // display, attachments, account-name resolution).
                    return (
                        <NewTemplatePreviewStep
                            entry={entry}
                            onChange={(updatedEntry) => setEntry(updatedEntry)}
                            companyId={companyId}
                            templates={templates}
                            accounts={accounts}
                            accountsLoading={accountsLoading}
                            accountsError={accountsError}
                            getAccountByNumber={getAccountByNumber}
                            getAccountsByType={getAccountsByType}
                            searchAccounts={searchAccounts}
                        />
                    );
                }
                return (
                    <PreviewStep
                        entry={entry}
                        onChange={(updatedEntry) => setEntry(updatedEntry)}
                        templates={templates}
                        accounts={accounts}
                        accountsLoading={accountsLoading}
                        accountsError={accountsError}
                        getAccountByNumber={getAccountByNumber}
                        getAccountsByType={getAccountsByType}
                        searchAccounts={searchAccounts}
                    />
                );

            default:
                return null;
        }
    };

    return (
        <>
            <style>{`
                .step-content-container {
                    background: white;
                    border-radius: 12px;
                    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
                    border: 1px solid #e5e7eb;
                    overflow: hidden;
                    margin-bottom: 2rem;
                }

                .step-body {
                    padding: 2rem;
                }

                @media (max-width: 768px) {
                    .step-body {
                        padding: 1.5rem;
                    }
                }
            `}</style>

            <div className="step-content-container">
                <div className="step-body">
                    {renderStepContent()}
                </div>
            </div>
        </>
    );
};

export default BookkeepingStepContent;